// component to add a button to show and hide a layer on map
export const displayLayerButton = (
  pImgs: any,
  pIdButton: string,
  pTitle: string,
  pSetterDisplayLayer: (value: boolean) => void,
  pLayerIds: number[],
  pView: any,
  pPositionButton: object,
  pLayer: any,
) => {
  // css for img button
  const img = document.createElement('img');
  img.src = pImgs.hide;
  img.style.width = '70%';

  // div for button
  const mobileButton = document.createElement('div');
  mobileButton.className =
    'esri-widget--button esri-widget esri-interactive home';
  mobileButton.id = pIdButton;
  mobileButton.title = pTitle;
  mobileButton.appendChild(img);
  mobileButton.style.display = 'none';

  // add event
  mobileButton.addEventListener('click', () => {
    const sublayer = pLayer
      .allSublayers.toArray().find((sublayer: any) => sublayer.id === pLayerIds[0]);
    const isVisible = sublayer ? sublayer.visible : false;
    const newValue = !isVisible;

    img.src = newValue ? pImgs.show : pImgs.hide;
    pSetterDisplayLayer(newValue);

    pLayerIds.forEach((layerId) => {
      const sub = pLayer
        .allSublayers.toArray().find((sublayer: any) => sublayer.id === layerId);
      if (sub) {
        sub.visible = newValue;
      }
    });
    pView.goTo(pView.extent);
  });

  // add button on map interface
  pView.ui.add(mobileButton, pPositionButton);
};
